import { YMaps, Map, Placemark } from 'react-yandex-maps';
import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {changePublishState, loadAdminObjects, logout, clearRedirect } from "./../../actions/actions";
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { fade } from '@material-ui/core/styles/colorManipulator';
import Pager from './../controls/Pager';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Header from './../Header';
import Footer from './../Footer';
import SearchBar from './../controls/SearchControl'
import { Link, Redirect } from 'react-router-dom';
import Toolbar from '@material-ui/core/Toolbar';
import Divider from '@material-ui/core/Divider';

const styles = theme => ({
    root: {
        width: '100%',
    },
    contentWrapper: {
        marginLeft: '3em',
        marginRight: '3em'
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },

    resetPadding: {
        padding: 0,
    },
    newColor: {
        borderRadius: 0,
        backgroundColor: 'transparent',
        borderBottom: '1px solid #76b5b8',
        boxShadow: 'none',
        '&::before': {
            height: 0
        },
    },
    color:{
        color:'#76b5b8'
    },
    title:{
        color:'#76b5b8',
        textOverflow: 'ellipsis',
        maxWidth: '95%'
    },
    headerStatic:{
        margin: '60px 0',
        fontSize: 26,
        fontFamily:'PT Sans Narrow, sans-serif',
        fontWeight: 'bold'
    },
    textStatic:{
        margin: '60px 0',
        maxWidth: '65%',
        color: '#5b5b5b'
    },
    blockDescription:{
        marginTop: '30px',
        marginBottom: '20px'
    },
    maps:{
        width: '100%',
        display: 'block',
        margin: '85 0',
        '&:nth-child(1)':{
            marginRight: 'auto',
            marginLeft: 'auto'
        }
    }
});

const mapState = { center: [53.901437, 27.570577], zoom: 7 };

export class ObjectsInspector extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            user:{},
            auth:false,
            bo_search: '',
            bo: []
        };
    }
    logout = () => {
        this.props.logout();
        this.setState({auth:false, user:{}, redirect:null});
    }

    componentWillMount() {
        let user = JSON.parse(localStorage.getItem('user'));
        if (user !== null &&  (user.role.indexOf('ROLE_SUPER_ADMIN') > -1 ||  user.role.indexOf('ROLE_SUPERVISOR')) > -1) {
            this.setState({auth: true, user: user});
            this.props.loadAdminObjects(user.token, 1);
        }
        
    }

    handlePublish = (id) => {
        this.props.changePublishState(id, this.state.user.token)
    }

    componentWillReceiveProps(nextProps) {
        console.log('Props received');
        console.log(nextProps);
        this.setState(nextProps);
    }

    updateInput = input => {
        this.setState({ bo_search: input.value});
    }; 
    handleSearch = (e) => {
        e.preventDefault();
        this.props.loadAdminObjects(this.state.user.token, 1, e.target['search'].value);
    }

    render () {
        if (this.state.auth == false) {
            return (<Redirect to="/login"/>)
        }
        
        const {classes, bo} = this.props;
        let bos = Array.isArray(bo)? (<Paper>
            {bo.map(item => (
                <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography className={classes.heading}>{item.object_name}|{item.is_published? 'Опубликован':'Скрыт'}</Typography>
                    </ExpansionPanelSummary>
                    <Divider />
                    <ExpansionPanelActions>
                        {/*<Button onClick={e => this.handlePublish(item.id)}>{item.is_published? 'Скрыть':'Опубликовать'}</Button>*/}
                        <Button component={Link} to={`/manage-object/${item.id}/`}>Редактировать</Button>
                    </ExpansionPanelActions><Divider />
                 <ExpansionPanelDetails>
                     <Typography>
                    <b>Наименование заказчика:</b>
                    <Typography>{item.client_org_name} ({item.client_org_country})</Typography>
                    <Typography>{item.client_org_city}, {item.client_org_street}, {item.client_org_block}, пом.{item.client_org_office} </Typography>
                    <Typography>сайт:  {item.client_org_website}</Typography>
                    <Typography>тел.: {item.client_org_phone}</Typography>
                    <Typography>e-mail: {item.client_org_email}</Typography>
                    <Typography>Ответственное лицо : Руководитель проекта {item.client_org_responsible}  </Typography>
                    <Typography>{item.object_name}</Typography>
                    <b>Разрешение</b>
                    <Typography>Специализированная инспекция Департамента Госстройнадзора  </Typography>
                    <Typography>Учетный номер объекта: {item.registration_number}</Typography>
                    <b>Начало работ</b>
                    <Typography>{item.development_start_date}</Typography>
                    <b>Окончание работ</b>
                    <Typography>{item.development_finish_date}</Typography>
                 </Typography>
                </ExpansionPanelDetails>



                </ExpansionPanel>
           ))}
        </Paper>) : (<Paper>There are no buildings in the system</Paper>)
        return (
            <div>                                                   
                {(this.state.user.role.indexOf('ROLE_SUPERVISOR')>=0) && (<Header link={{to:'/supervision/', title: this.state.user.org}} />)}
                {(this.state.user.role.indexOf('ROLE_SUPER_ADMIN')>=0) && (<Header link={{to:'/admin/', title: this.state.user.org}} />)}
                <Toolbar>
                    {((this.state.user.role.indexOf('ROLE_SUPERVISOR')>=0)) &&(<Button component={Link} to="/supervision">Вернуться</Button>)}
                    {((this.state.user.role.indexOf('ROLE_SUPER_ADMIN')>=0)) &&(<Button component={Link} to="/admin">Вернуться</Button>)}
                    <Button component={Link} to="/newobject">Создать Новый объект</Button>
                    <Button onClick={this.logout}>Выйти</Button>
                </Toolbar>
                <div className={classes.contentWrapper}>
                    <div className={classes.root}>
                        <form onSubmit={this.handleSearch}>
                            <SearchBar placeholderInput='Введите данные объекта для его поиска' textBtn='Поиск' onChange={this.updateInput} />
                        </form>
                        { bos }
                        <Pager token={this.state.user.token}
                               search={this.state.bo_search}
                               page={this.props.page}
                               total={this.props.total}
                               handle={this.props.loadAdminObjects}
                        />
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

ObjectsInspector.defaultProps = {
    page: 1,
    bo: []
}
function mapDispatch(dispatch) {
    return {
        loadAdminObjects: bindActionCreators(loadAdminObjects, dispatch),
        logout: bindActionCreators(logout, dispatch),
        clearRedirect: bindActionCreators(clearRedirect, dispatch),
        changePublishState: bindActionCreators(changePublishState, dispatch),
    };
}


function select(state, props) {
    const { bo } = state;
    console.log('SELECT');
    console.log(bo);

    return {
        bo: bo.bo || [],
        page: bo.page || 1,
        total: bo.total || 50
    };
}

// Objects.propTypes = {
//     classes: PropTypes.object.isRequired,
// };

export const ObjectsInspectorWithStyles = withStyles(styles)(ObjectsInspector);

export default connect(select, mapDispatch)(ObjectsInspectorWithStyles);


// WEBPACK FOOTER //
// ./assets/src/js/components/pages/AdminObjects.jsx